var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 99,
    viewBox: "0 0 127 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2152 6.68681C46.0578 -2.22892 58.8555 -2.22893 63.6982 6.6868L82.4419 41.1956L84.4343 37.5275C87.6704 31.5696 96.2224 31.5695 99.4585 37.5275L125.952 86.3039C129.046 92.0001 124.922 98.9328 118.44 98.9328H65.4531C64.582 98.9328 63.7536 98.8076 62.9795 98.5771H12.8107C3.11031 98.5771 -3.06075 88.2026 1.56922 79.6785L41.2152 6.68681ZM88.2647 21.5627C93.4398 21.5627 97.6351 17.1034 97.6351 11.6025C97.6351 6.10155 93.4398 1.64218 88.2647 1.64218C83.0896 1.64218 78.8943 6.10155 78.8943 11.6025C78.8943 17.1034 83.0896 21.5627 88.2647 21.5627Z",
    fill: "url(#paint0_linear_495_7991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_495_7991",
    x1: 63.3506,
    y1: -31.2994,
    x2: 63.3506,
    y2: 91.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBg);
export default __webpack_public_path__ + "static/media/card-bg.256e8348fe6870c441a9394d45d0f378.svg";
export { ForwardRef as ReactComponent };